import { Controller } from '@hotwired/stimulus';
import { Offcanvas } from 'bootstrap';

// Turbo snapshots the page before navigating away from it. Bootstrap's own
// hide() is animated, so the snapshot would still be taken with the offcanvas
// open and Back would restore it with its backdrop and scroll lock.
export default class OffcanvasController extends Controller<HTMLElement> {
  public close(): void {
    if (!this.element.classList.contains('show')) {
      return;
    }

    Offcanvas.getInstance(this.element)?.dispose();
    this.element.classList.remove('show');
    this.element.removeAttribute('aria-modal');
    this.element.removeAttribute('role');
    this.element.style.removeProperty('visibility');

    document
      .querySelectorAll('.offcanvas-backdrop')
      .forEach(backdrop => backdrop.remove());
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }
}
